export default {"src":"/_next/static/media/how-to-use-icon-3.0c2ec387.svg","height":66,"width":51,"blurWidth":0,"blurHeight":0};